module.exports = __webpack_public_path__ + "static/img/ruzhu.14b49e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ruzhu.png
// module id = eScX
// module chunks = 1